const DEFAULTS = {
  REMARKS: 500,
  ADDRESS: 1000,
  TEXTAREA_DEFAULT: 2000,
} as const;

export type TextLimitKey = keyof typeof DEFAULTS;

function isPositiveInt(value: unknown): value is number {
  return typeof value === "number" && Number.isInteger(value) && value > 0;
}

export function textLimit(key: TextLimitKey): number {
  const raw =
    typeof window !== "undefined" ? window.config?.TEXT_LIMITS?.[key] : undefined;
  return isPositiveInt(raw) ? raw : DEFAULTS[key];
}

export function resolveMaxLength(
  fromBackend: unknown,
  fallback: TextLimitKey,
): number {
  return isPositiveInt(fromBackend) ? fromBackend : textLimit(fallback);
}

export function clampText(value: string, max: number): string {
  return value.length > max ? value.slice(0, max) : value;
}
